import FinetuneSuggestionService from '@modules/Policy/services/FinetuneSuggestion.service';
import {
  formatThresholdApplyResult,
  getApiErrorMessage
} from '@shared/utils/finetune';

export default {
  data() {
    return {
      isApplyingThresholds: false
    };
  },
  methods: {
    async runThresholdApply(request) {
      this.isApplyingThresholds = true;
      try {
        const response = await request();
        formatThresholdApplyResult(response || {}).forEach(({ type, message }) => {
          this.$message[type](message);
        });
      } catch (error) {
        this.$message.error(
          getApiErrorMessage(error, 'Failed to apply thresholds.')
        );
      } finally {
        this.isApplyingThresholds = false;
      }
    },
    runApplyThresholds(urlsPayload) {
      return this.runThresholdApply(() =>
        FinetuneSuggestionService.applyThresholds(urlsPayload)
      );
    },
    runApplyThresholdsByTarget(target, thresholds) {
      return this.runThresholdApply(() =>
        FinetuneSuggestionService.applyThresholdsByTarget(target, thresholds)
      );
    }
  }
};
